import { useEffect, useState } from "react";
import { financialModelingPrepApiKey } from "data/keys";
import axios from 'axios';

export default function useMAfeed() {
    const [maFeed, setData] = useState([]);
    const [loading,setLoading] = useState(false)
    useEffect(() => {
      const fetchData = async () => {
        try {
          setLoading(true)
          const response = await axios.get(
            `https://financialmodelingprep.com/api/v4/mergers-acquisitions-rss-feed?page=0&apikey=${financialModelingPrepApiKey}
            `
          );
          setData(response.data);
        } catch (error) {
          console.error(error);
        }
        finally{ 
        setLoading(false)
        }
      };
  
     fetchData();
    }, []);
  
    return { maFeed };
  }